import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventData} from '../types';

import AlarmIcon from '../../../../../assets/icons/alarm.svg';
import {getYcLogoFile} from '../../../../../utils/entity/file';

export const getData = (event: NotificationEvent): EventData => {
  let title = i18n.t('shared:coach_verified_congrats');

  switch (event.type) {
    case 'coach_became_restricted':
      title = i18n.t('shared:coach_profile_verified_congrats');
      break;
    case 'coach_verification_required':
      title = i18n.t('shared:coach_verification_required_long');
      break;
    default:
      break;
  }

  return {
    avatar: getYcLogoFile(180),
    avatarPlaceholder: 'Your Coach',
    icon: AlarmIcon,
    iconGradient: 'success',
    title,
  };
};
